import { CarPdfViewer } from "@app/components/PdfViewer";
import { CarAssetClassDftItem } from "../useAssetClassSummaryStat";
import { DftTotalReturnsPdfChart } from "./DftTotalReturnsPdfChart";
import { DftVersusTenYearReturnPdfChart } from "./DftVersusTenYearReturnPdfChart";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { useUser } from "@app/pages/settings/useUser";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { CarPdfBox } from "@app/components/PdfBox";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { CarPdfStatBox } from "@app/components/PdfStatBox";
import { DftVersusTenYearReturnPdfChartLegend } from "./DftVersusTenYearReturnPdfChartLegend";

export const DFT_CHART_HEIGHT = 192;

interface PdfDftSingleReportProps {
  dftItem?: CarAssetClassDftItem;
  isLoading: boolean;
}

export const PdfDftSingleReport = ({
  dftItem,
  isLoading,
}: PdfDftSingleReportProps) => {
  const user = useUser();

  const title = dftItem?.name;
  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {dftItem && (
          <CarPdfPage
            sectionTitle="Historical Analysis"
            reportTitle="Distance from Trend - Single"
            footer={footer}
          >
            <CarPdfBox
              style={{
                flexDirection: "row",
                marginTop: 24,
              }}
            >
              <CarPdfTypography variant="v14Semibold" dense>
                {dftItem.name}
              </CarPdfTypography>
              <CarPdfTypography
                variant="v12Regular"
                style={{ marginLeft: "auto", paddingTop: 1 }}
                dense
                italic
              >
                Start Date {dftItem.startDate}
              </CarPdfTypography>
            </CarPdfBox>
            <CarPdfStatBox
              style={{ marginTop: 5 }}
              items={dftItem.statItems}
              isWhiteContext
            />
            <DftTotalReturnsPdfChart
              width={defaultClientPageSize.width}
              height={DFT_CHART_HEIGHT}
              style={{ marginTop: 16 }}
              dftItem={dftItem}
              isWhiteContext
            />
            <CarPdfTypography
              variant="v14Semibold"
              dense
              style={{ marginTop: 18 }}
            >
              Real 10 Year Return vs. Distance from Trend
            </CarPdfTypography>
            <DftVersusTenYearReturnPdfChart
              width={defaultClientPageSize.width}
              height={DFT_CHART_HEIGHT}
              style={{ marginTop: 6 }}
              dftItem={dftItem}
              isWhiteContext
            />
            <DftVersusTenYearReturnPdfChartLegend style={{ marginTop: 16 }} />
          </CarPdfPage>
        )}
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
